import { apiClient } from './client';
import { buildApiEndpoint } from './config';

// User Response interface
export interface UserResponse {
  id: string;
  user_id: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  created_at?: string;
  updated_at?: string;
}

// User Service Class
export class UserService {
  /**
   * Create a new user
   * This creates a user record in the backend associated with the Firebase auth user
   * @returns Promise with user data
   */
  public async createUser(): Promise<UserResponse> {
    try {
      const endpoint = buildApiEndpoint('users/');
      const response = await apiClient.post<UserResponse>(endpoint, {});
      return response.data;
    } catch (error) {
      console.error('Failed to create user:', error);
      throw error;
    }
  }

  /**
   * Get user by ID
   * @param userId - The user ID
   * @returns Promise with user data
   */
  public async getUserById(userId: string): Promise<UserResponse> {
    try {
      const endpoint = buildApiEndpoint(`users/${userId}`);
      const response = await apiClient.get<UserResponse>(endpoint);
      return response.data;
    } catch (error) {
      console.error(`Failed to fetch user ${userId}:`, error);
      throw error;
    }
  }
}

// Export singleton instance
export const userService = new UserService();

